export const DYNAMIC_INVOICE_USAGE_LINE_ITEM_CHART_RESOLUTION = Object.freeze({
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
});

export type DynamicInvoiceUsageLineItemChartResolution =
  (typeof DYNAMIC_INVOICE_USAGE_LINE_ITEM_CHART_RESOLUTION)[keyof typeof DYNAMIC_INVOICE_USAGE_LINE_ITEM_CHART_RESOLUTION];

export const DYNAMIC_INVOICE_USAGE_LINE_ITEM_CHART_RESOLUTION_LABELS = Object.freeze({
  [DYNAMIC_INVOICE_USAGE_LINE_ITEM_CHART_RESOLUTION.DAY]: 'Daily',
  [DYNAMIC_INVOICE_USAGE_LINE_ITEM_CHART_RESOLUTION.WEEK]: 'Weekly',
  [DYNAMIC_INVOICE_USAGE_LINE_ITEM_CHART_RESOLUTION.MONTH]: 'Monthly',
});
